import { io } from 'socket.io-client';
import { config, getAuthToken } from './bridge.js';

const LOBBY = 'roulette';

let socket = null;
let subscribed = false;
const listeners = {};
const lifecycleHandlers = { connect: [], disconnect: [], reconnect: [] };

export function onSocketLifecycle(kind, fn) {
  if (!lifecycleHandlers[kind]) return () => {};
  lifecycleHandlers[kind].push(fn);
  return () => {
    const arr = lifecycleHandlers[kind];
    const i = arr.indexOf(fn);
    if (i >= 0) arr.splice(i, 1);
  };
}

function fireLifecycle(kind, info) {
  for (const fn of lifecycleHandlers[kind]) {
    try { fn(info); } catch (e) {}
  }
}

export async function connectSocket() {
  if (socket && socket.connected) return socket;
  const token = await getAuthToken();
  const url = (config.socketUrl || config.backendUrl).replace(/\/$/, '');
  socket = io(url, {
    transports: ['websocket'],
    auth: token ? { token } : {},
    reconnection: true,
    reconnectionDelay: 1000,
  });
  socket.on('connect', () => {
    if (subscribed) socket.emit(`${LOBBY}_lobby_subscribe`);
    fireLifecycle('connect');
  });
  socket.on('reconnect', () => {
    if (subscribed) { try { socket.emit(`${LOBBY}_lobby_subscribe`); } catch (_) {} }
    fireLifecycle('reconnect');
  });
  socket.on('disconnect', (reason) => fireLifecycle('disconnect', { reason }));
  for (const event of Object.keys(listeners)) {
    socket.on(event, (payload) => listeners[event].forEach((fn) => fn(payload)));
  }
  return socket;
}

/** Join the roulette lobby room; the server replies with a state snapshot. */
export function subscribeLobby() {
  subscribed = true;
  if (socket && socket.connected) socket.emit(`${LOBBY}_lobby_subscribe`);
}

export function unsubscribeLobby() {
  subscribed = false;
  if (socket && socket.connected) {
    try { socket.emit(`${LOBBY}_lobby_unsubscribe`); } catch (_) {}
  }
}

export function on(event, handler) {
  listeners[event] = listeners[event] || [];
  listeners[event].push(handler);
  if (socket) socket.on(event, handler);
  return () => off(event, handler);
}

export function off(event, handler) {
  const arr = listeners[event];
  if (!arr) return;
  const i = arr.indexOf(handler);
  if (i >= 0) arr.splice(i, 1);
  if (socket) socket.off(event, handler);
}

export function isConnected() { return !!(socket && socket.connected); }

/** Tear down for the Flutter cleanup hook. */
export function disconnectSocket() {
  unsubscribeLobby();
  if (socket) {
    try { socket.removeAllListeners(); } catch (_) {}
    try { socket.disconnect(); } catch (_) {}
  }
  socket = null;
  for (const key of Object.keys(listeners)) delete listeners[key];
}
